import { render, staticRenderFns } from "./ListOfUser.vue?vue&type=template&id=2a97bae2&"
import script from "./ListOfUser.vue?vue&type=script&lang=js&"
export * from "./ListOfUser.vue?vue&type=script&lang=js&"
import style0 from "./ListOfUser.vue?vue&type=style&index=0&id=2a97bae2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports